export enum ToastType {
  INFO,
  WARN,
  ERROR,
  SUCCESS
}
